export type MechanismType =
  | 'socket'
  | 'bathroom_socket'
  | 'kitchen_socket'
  | 'switch'
  | 'switch_double'
  | 'internet'
  | 'tv'
  | 'usb';

export type MasterSwitchMode = 'simple' | 'realistic';

export interface CustomBlockPayload {
  version: 1;
  label?: string;
  orientation: 'horizontal' | 'vertical';
  mechanisms: Array<{
    type: MechanismType;
    label?: string;
    lineId?: string | null;
  }>;
}

export interface PlacedItem {
  id: string;
  type: string;
  u: number;
  v: number;
  lineId: string | null;
  rotation?: 0 | 90 | 180 | 270;
  blockId?: string;
  customBlock?: CustomBlockPayload;
  switchLines?: {
    left?: string | null;
    right?: string | null;
  };
  masterMode?: MasterSwitchMode;
}

export interface PlanCalibration {
  pxPerMm: number;
  refSegmentSourcePx: {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
  };
  refLengthMm: number;
  backgroundHash: string;
  confidence: 'user';
  createdAt: string;
}

declare const anchorBrand: unique symbol;
export type Anchor = { readonly [anchorBrand]: true };

export type DimensionId = string;

export interface Dimension {
  id: DimensionId;
  a: Anchor;
  b: Anchor;
  offsetPx: number;
  labelOverride?: string | null;
  locked?: boolean;
}

export interface Transform {
  scale: number;
  offsetX: number;
  offsetY: number;
}

export interface BgTransform {
  /** Clockwise quarter-turns around the plan centre; omitted in legacy projects. */
  rotation?: 0 | 90 | 180 | 270;
  x: number;
  y: number;
  scale: number;
}

export interface Line {
  id: string;
  name: string;
  color: string;
}

export const LINE_COLORS = [
  '#ef4444',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#06b6d4',
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
];
